import { Box, Grid, Typography } from "@material-ui/core";
import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core/styles';
import { useDispatch } from 'react-redux';
import { useState, useEffect, ChangeEvent, ChangeEventHandler } from 'react';

const useStyles = makeStyles({
    gridItem: { margin: 8 },
    formContainer: {
        padding: 16
    }
});

interface FormDataProps {
    formData: {
        nomeProduto: string;
        nomeComercial: string;
        numeroLote: string;
        dataFabrico: string;
        dataExpiracao: string;
        nomeFabricante: string;
        paisOrigem: string;
        fornecedor: string;
        dataRecepcao: string;
    };
    handleChange: ChangeEventHandler<HTMLInputElement>;
  }

const IdentificaçãoProduto = ({ formData, handleChange }: FormDataProps) => {
    const classes = useStyles();
    return (
        <Box className={classes.formContainer}>
            {/* <Typography variant="h5" style={{ marginBottom: 24 }}>
      Dados da Unidade Sanitária
    </Typography> */}

            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <TextField
                        required
                        type="text"
                        label="Nome do produto (DCI)"
                        fullWidth
                        size="small"
                        name="nomeProduto"
                        variant="outlined"
                        onChange={handleChange}
                        value={formData.nomeProduto}
                    />
                </Grid>

                <Grid item xs={6} md={6}>
                    <TextField
                        required
                        type="text"
                        label="Nome comercial"
                        fullWidth
                        size="small"
                        name="nomeComercial"
                        variant="outlined"
                        onChange={handleChange}
                        value={formData.nomeComercial}
                    />
                </Grid>
                <Grid item xs={6} md={6}>
                    <TextField
                        required
                        type="text"
                        label="Número do lote"
                        fullWidth
                        size="small"
                        name="numeroLote"
                        variant="outlined"
                        onChange={handleChange}
                        value={formData.numeroLote}
                    />
                </Grid>

                <Grid item xs={6}>
                    <TextField
                        required
                        type="date"
                        label="Data de Fábrico"
                        fullWidth
                        size="small"
                        name="dataFabrico"
                        variant="outlined"
                        onChange={handleChange}
                        value={formData.dataFabrico}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </Grid>

                <Grid item xs={6}>
                    <TextField
                        required
                        type="date"
                        label="Data de Expiração"
                        fullWidth
                        size="small"
                        name="dataExpiracao"
                        variant="outlined"
                        onChange={handleChange}
                        value={formData.dataExpiracao}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </Grid>

                <Grid item xs={6} md={6}>
                    <TextField
                        required
                        type="text"
                        label="Nome do fabricante"
                        fullWidth
                        size="small"
                        name="nomeFabricante"
                        variant="outlined"
                        onChange={handleChange}
                        value={formData.nomeFabricante}
                    />
                </Grid>
                <Grid item xs={6} md={6}>
                    <TextField
                        required
                        type="text"
                        label="País de origem"
                        fullWidth
                        size="small"
                        name="paisOrigem"
                        variant="outlined"
                        onChange={handleChange}
                        value={formData.paisOrigem}
                    />
                </Grid>
                <Grid item xs={6} md={6}>
                    <TextField
                        required
                        type="text"
                        label="Nome do distribuidor / fornecedor"
                        fullWidth
                        size="small"
                        name="fornecedor"
                        variant="outlined"
                        onChange={handleChange}
                        value={formData.fornecedor}
                    />
                </Grid>
                <Grid item xs={6} md={6}>
                    <TextField
                        required
                        type="date"
                        label="Data da recepção"
                        fullWidth
                        size="small"
                        name="dataRecepcao"
                        variant="outlined"
                        onChange={handleChange}
                        value={formData.dataRecepcao}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </Grid>
            </Grid>
        </Box>
    )
}

export default IdentificaçãoProduto
